import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppText } from 'shared/UI/UIKit/Text';
import type { RoomModalProps } from '../../types';
import { RoomModalFooter } from '../../Footer';
import { useRemoveService } from '../model';
import styles from './Remove.module.scss';

interface RemoveRoomModalProps extends RoomModalProps {
  onItemRemove: () => void;
}

export const RemoveRoomModal = ({
  selectedRoom,
  visible,
  hide,
  onItemRemove,
}: RemoveRoomModalProps) => {
  const {
    state: { loading },
    methods: { hideModal, confirm },
  } = useRemoveService({ selectedRoom, hide, onItemRemove });

  const footer = <RoomModalFooter onSubmit={confirm} hideModal={hideModal} title="Удалить" />;
  const content = (
    <AppFlex unit="8" className={styles.content}>
      <AppText size={16} type="secondary">
        Подтвердите удаление аудитории
      </AppText>
      <AppText size={18}>{selectedRoom?.name}</AppText>
    </AppFlex>
  );

  return (
    <AppModal
      visible={visible}
      onCancel={hideModal}
      size="auto"
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      title="Удаление аудитории"
      maskClosable={false}
    />
  );
};
